import React from 'react';
import FlipClockCountdown from '@leenguyen/react-flip-clock-countdown';
import '@leenguyen/react-flip-clock-countdown/dist/index.css';
import Typography from '@mui/joy/Typography';

interface StartingSoonProps {
  targetDateTime: string;
}

const StartingSoon: React.FC<StartingSoonProps> = ({ targetDateTime }) => {
  const parseDateTime = (dateTimeString: string): number => {
    // The Date constructor can directly parse ISO 8601 format
    const targetDate = new Date(dateTimeString);
    return targetDate.getTime();
  };

  const targetTimestamp = parseDateTime(targetDateTime);

  return (
    <>
    <Typography level="h1" className="my-10">Event Starting Soon...</Typography>
      <FlipClockCountdown to={targetTimestamp}  digitBlockStyle={{ height: "8rem", width : "4rem"}}/>
    </>
  );
};

export default StartingSoon;